import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["how-long-can-your-long-run-be"]!;

export function Body() {
  return (
    <>
      <p>
        How much longer is today’s run than your longest run in the last month? A large
        Danish-led study from 2025 examined the link between increases in single-run
        distance and running injuries.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Researchers from Aarhus University followed 5,205 runners for 18 months using data from
        their Garmin watches. That added up to 588,071 runs. Along the way, 1,820 of the runners
        reported a running injury.
      </p>
      <p>
        For each run they asked a simple question: how long was this run compared with the
        longest run in the previous 30 days?
      </p>

      <h2>What they found</h2>
      <p>
        Runs that were more than 10 percent longer than the longest run of the past month were
        linked to a higher rate of overuse injuries. Compared with runs that stayed within 10
        percent, the rate was about 1.6 times higher when the run was 10 to 30 percent longer,
        about 1.5 times higher at 30 to 100 percent longer, and about 2.3 times higher when the
        run was more than twice as long.
      </p>
      <p>
        The more familiar rules based on weekly mileage did not show the same pattern. A sudden
        long session seemed to matter more than how much you ran in total that week.
      </p>

      <h2>What it means for you</h2>
      <p>
        If your longest run in the past month was 15 km, a 16.5 km long run is within 10
        percent. A 20 km run is a third longer. That doesn't mean you will get injured. It means
        the jump is bigger than it might feel on a good day.
      </p>
      <p>
        Build your long run up step by step. If you have had a break, start from what you have
        actually run in the last month, not from what you used to run. If a run grows on
        the day, reassess the following sessions in light of the extra distance and how you recover.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        This was an observational study. It shows a link between big jumps and injuries, not
        that the jumps caused them. The 10 percent figure is a way of grouping the data. It is
        not a line where running suddenly becomes safe or dangerous, and your own tolerance
        depends on your history, your body and how the rest of your training looks.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training compares a proposed run with the longest completed run in the previous 30 days,
        when the history is complete enough. An increase above 10 percent prompts a review
        before the session is recommended. It is not permission to increase by 10 percent
        each time, and missing runs can make the comparison unavailable.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Frandsen et al. (2025), How much running is too much? Identifying high-risk running
          sessions in a 5200-person cohort study.{" "}
          <a href="https://doi.org/10.1136/bjsports-2024-109380">British Journal of Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
